import React, { useState, useEffect } from 'react';
import { Navbar } from '../../components/Navbar';
import { StickyFooter } from '../../components/StickyFooter';
import { CheckCircleIcon, ChevronRightIcon, ChevronLeftIcon } from 'lucide-react';
export function BookNowUS() {
  const [step, setStep] = useState(1);
  const [serviceType, setServiceType] = useState('');
  const [zipCode, setZipCode] = useState('');
  const [date, setDate] = useState('');
  useEffect(() => {
    document.title = "Book Care or Rent Equipment | Care Nomad US";
  }, []);
  return <div className="min-h-screen w-full bg-gray-50 flex flex-col" data-id="element-2232" data-mp="fi52zq8vkes4">
      <Navbar data-id="element-2233" data-mp="u7u7nvg6f0x5" />
      
      <main className="flex-1 py-12 lg:py-20" data-id="element-2234" data-mp="u69ea95llo0v">
        <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2235" data-mp="p8hk18hhdpti">
          <div className="bg-white rounded-3xl shadow-xl border border-gray-100 overflow-hidden" data-id="element-2236" data-mp="p99hypyjvzmy">
            {/* Header */}
            <div className="bg-[#007a87] px-8 py-6 text-white" data-id="element-2237" data-mp="135wif2ppp7xm">
              <h1 className="text-2xl font-bold mb-2" data-id="element-2238" data-mp="yaqww5081va2">Find Care or Rent Gear</h1>
              <div className="flex items-center gap-2 text-sm text-white/80" data-id="element-2239" data-mp="263zg37vfqjpq">
                <span className={step >= 1 ? 'text-white font-bold' : ''} data-id="element-2240" data-mp="2b1hguazatsmn">Service</span>
                <ChevronRightIcon className="w-4 h-4" data-id="element-2241" data-mp="2g1diw4ofr9zk" />
                <span className={step >= 2 ? 'text-white font-bold' : ''} data-id="element-2242" data-mp="2fzsp4h9y3v2r">Details</span>
                <ChevronRightIcon className="w-4 h-4" data-id="element-2243" data-mp="2l1rufwp8x22c" />
                <span className={step >= 3 ? 'text-white font-bold' : ''} data-id="element-2244" data-mp="2p222rg0ig4kd">Confirm</span>
              </div>
            </div>

            <div className="p-8" data-id="element-2245" data-mp="2tztry29rtckv">
              {step === 1 && <div className="space-y-6 animate-fade-in" data-id="element-2246" data-mp="2yrvb885cw3ke">
                  <h2 className="text-xl font-bold text-[#1a2332]" data-id="element-2247" data-mp="2ysde3nmixg1a">What are you looking for?</h2>
                  <div className="space-y-3" data-id="element-2248" data-mp="33pwsqon4vutr">
                    <button onClick={() => {
                  setServiceType('nanny');
                  setStep(2);
                }} className="w-full text-left p-4 rounded-xl border-2 border-gray-200 hover:border-[#007a87] hover:bg-[#007a87]/5 transition-all" data-id="element-2249" data-mp="38qb3ieg4divh">
                      <div className="font-bold text-[#1a2332]" data-id="element-2250" data-mp="18niaf6rsslwx">Find a Nanny / Nurse</div>
                      <div className="text-sm text-[#5a6a7a] mt-1" data-id="element-2251" data-mp="18lp27n1jdtmt">Connect with independent caregivers and travel nurses</div>
                    </button>
                    <button onClick={() => {
                  setServiceType('rental');
                  setStep(2);
                }} className="w-full text-left p-4 rounded-xl border-2 border-gray-200 hover:border-[#007a87] hover:bg-[#007a87]/5 transition-all" data-id="element-2252" data-mp="1hn59hlx21fmt">
                      <div className="font-bold text-[#1a2332]" data-id="element-2253" data-mp="25e2cuaasb4mg">Rent Mobility / Baby Gear</div>
                      <div className="text-sm text-[#5a6a7a] mt-1" data-id="element-2254" data-mp="21bnrnjjn7ss0">Scooters, wheelchairs, strollers delivered to you</div>
                    </button>
                  </div>
                </div>}

              {step === 2 && <div className="space-y-6 animate-fade-in" data-id="element-2255" data-mp="6zzd3ihbps85">
                  <div className="flex items-center gap-3 mb-6" data-id="element-2256" data-mp="3szdj64024mwl">
                    <button onClick={() => setStep(1)} className="p-2 hover:bg-gray-100 rounded-full transition-colors" data-id="element-2257" data-mp="vteixx36nyi">
                      <ChevronLeftIcon className="w-5 h-5 text-[#5a6a7a]" data-id="element-2258" data-mp="3jac4qi95udkq" />
                    </button>
                    <h2 className="text-xl font-bold text-[#1a2332]" data-id="element-2259" data-mp="3o8do74ai0ewq">Where and When?</h2>
                  </div>
                  
                  <div className="space-y-4" data-id="element-2260" data-mp="39a32onshlxxf">
                    <div data-id="element-2261" data-mp="3eapmfueh6752">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2262" data-mp="3eazfjqutguez">US ZIP Code</label>
                      <input type="text" value={zipCode} onChange={e => setZipCode(e.target.value)} placeholder="e.g. 27701 (Durham), 27601 (Raleigh)" className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:ring-2 focus:ring-[#007a87] focus:outline-none" data-id="element-2263" data-mp="30bzu0s2lovn1" />
                    </div>
                    <div data-id="element-2264" data-mp="2zjq81f4db25n">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2265" data-mp="2umzkk6q8h4a7">
                        {serviceType === 'rental' ? 'Delivery Date' : 'Care Start Date'}
                      </label>
                      <input type="date" value={date} onChange={e => setDate(e.target.value)} className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:ring-2 focus:ring-[#007a87] focus:outline-none" data-id="element-2266" data-mp="2lmkw4yhz392h" />
                    </div>
                  </div>

                  <button onClick={() => setStep(3)} disabled={!zipCode || !date} className="w-full bg-[#5a55ea] hover:bg-[#4b47c4] disabled:bg-gray-300 disabled:cursor-not-allowed text-white font-bold py-3.5 rounded-xl transition-colors mt-6" data-id="element-2267" data-mp="21y2fj5b193ze">
                    Continue
                  </button>
                </div>}

              {step === 3 && <div className="space-y-6 animate-fade-in text-center py-8" data-id="element-2268" data-mp="dd3nj50tq70q">
                  <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-2269" data-mp="hfrv79dsx7w4">
                    <CheckCircleIcon className="w-10 h-10 text-green-600" data-id="element-2270" data-mp="mdtftyqvlf9p" />
                  </div>
                  <h2 className="text-2xl font-bold text-[#1a2332] mb-2" data-id="element-2271" data-mp="3lvj5d1rgd1rk">Searching for Matches...</h2>
                  <p className="text-[#5a6a7a] mb-8" data-id="element-2272" data-mp="3pwcw02wa4uo5">
                    We are scanning our network for available {serviceType === 'rental' ? 'equipment' : 'professionals'} near {zipCode} starting on {date}.
                  </p>
                  <a href={`/us/${serviceType === 'rental' ? 'equipment-rentals' : 'nannies'}`} className="inline-block bg-[#007a87] hover:bg-[#005c66] text-white font-bold py-3.5 px-8 rounded-xl transition-colors" data-id="element-2273" data-mp="3i3aq2nnc2rl">
                    View Available Options
                  </a>
                </div>}
            </div>
          </div>
        </div>
      </main>

      <StickyFooter data-id="element-2274" data-mp="9b8uu4mu5805" />
    </div>;
}